import { promptList } from './ChatComposer';

export function draftPartOf(item) {
  return (item.parts ?? []).find((part) => part.type === 'draft') ?? null;
}

export function readerLocale() {
  if (typeof navigator === 'undefined') {
    return 'en-US';
  }
  return navigator.language || navigator.languages?.[0] || 'en-US';
}

// The follow-up prompts to offer: the newest turn that suggested some, or
// else the briefing's own.
export function latestChatPrompts(messages, briefing) {
  const fromThread = [...(messages ?? [])]
    .reverse()
    .find((item) => promptList(item.chat_prompts).length > 0);
  if (fromThread) {
    return promptList(fromThread.chat_prompts);
  }
  return promptList(
    briefing?.document?.chat_prompts ?? briefing?.document?.questions
  );
}
